import { createContext, useContext } from 'react';

export interface PreviewModeValue {
  isPreview: boolean;
  campaignId?: string;
}

const DEFAULT: PreviewModeValue = { isPreview: false };

/**
 * 광고주 미리보기 모드 컨텍스트.
 * isPreview=true일 때 isAdmin 체크를 false로 오버라이드하여 게스트 뷰를 렌더링한다.
 * campaignId가 있으면 해당 캠페인으로 필터링된 데이터를 표시한다.
 */
export const PreviewModeContext = createContext<PreviewModeValue>(DEFAULT);

export function usePreviewMode(): boolean {
  return useContext(PreviewModeContext).isPreview;
}

export function usePreviewCampaignId(): string | undefined {
  return useContext(PreviewModeContext).campaignId;
}
